import { Link } from 'react-router-dom';
import { ROUTES } from '@/config/routes';
import { MediaCard } from '@/kit';
import { EditorialImage } from '@/components/editorial/EditorialImage';
import type { MockProfile } from '@/data/mockProfiles';
import { capture } from '@/modules/heat/signals';

interface GridTileProps {
  profile: MockProfile;
  /** Index for the optional plate number overlay. */
  index?: number;
  /** Show the handle row beneath the scene (off by default for the dense wall). */
  showLabel?: boolean;
}

/**
 * Contact-sheet tile.
 *
 * Now the shared `MediaCard`, so this and HOTTR.men's roster cards are one
 * object: same status position, same name treatment, same scrim, same hover,
 * same border behaviour. The square crop and the editorial plate number stay —
 * they are what makes the dense wall feel like `.app` rather than a catalogue.
 *
 * The procedural EditorialImage rides in through the card's `media` slot, so
 * profiles without a photo still get a generated scene instead of a hole.
 */
export const GridTile = ({ profile, index, showLabel = false }: GridTileProps) => (
  <MediaCard
    as={Link}
    href={ROUTES.profile(profile.handle)}
    onClick={() => capture('profile_view', 'grid', profile.id)}
    aspect="square"
    name={profile.handle}
    meta={showLabel ? `${profile.distance} · ${profile.location}` : undefined}
    live={profile.presence === 'live'}
    index={index}
    media={
      <EditorialImage
        scene={profile.scene}
        seed={profile.sceneSeed}
        photoUrl={profile.photos[0]}
        aspect="aspect-square"
      />
    }
  />
);
